import { Globe, Mail } from "lucide-react";
import { useT } from "@spinning-top/koru-nova-frontend-i18n";

import type { FC } from "react";

import { SalusLogo } from "../../components/salus-logo.tsx";

const LINK_CLASS =
  "flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-primary";

export const AboutPage: FC = () => {
  const t = useT("about");
  return (
    <div className="flex h-full items-center justify-center overflow-y-auto p-6">
      <div className="w-full max-w-md rounded-2xl border border-border-soft bg-background px-8 py-10 text-center shadow-card">
        <h1 className="sr-only">KORU Salus</h1>
        <div className="flex justify-center">
          <SalusLogo size={58} tone="theme" />
        </div>
        <div className="mt-9 flex flex-col items-center gap-5 border-t border-border-soft pt-7">
          <div className="flex flex-col items-center gap-3">
            <p className="text-sm text-muted-foreground">{t("made_by")}</p>
            <img src="/branding/spinning-top.svg" alt="Spinning Top" className="h-10 w-auto" />
          </div>
          <nav className="flex items-center gap-4" aria-label={t("links_aria")}>
            <a
              href="https://www.spinningtop.it"
              target="_blank"
              rel="noreferrer"
              className={LINK_CLASS}
            >
              <Globe className="h-4 w-4" aria-hidden="true" />
              {t("link_website")}
            </a>
            <a href="mailto:info@spinningtop.it" className={LINK_CLASS}>
              <Mail className="h-4 w-4" aria-hidden="true" />
              {t("link_contact")}
            </a>
          </nav>
          <p className="max-w-xs text-sm leading-relaxed text-muted-foreground/70">
            {t("copyright")}
            <br />
            {t("rights")}
          </p>
        </div>
      </div>
    </div>
  );
};
